<h2 mat-dialog-title>{{ data.titulo }}</h2>

<mat-dialog-content>
  <p>{{ data.mensaje }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancelar()">
    {{ data.textoBotonCancelar || "Cancelar" }}
  </button>

  <button mat-flat-button color="primary" (click)="confirmar()">
    {{ data.textoBotonConfirmar || "Confirmar" }}
  </button>
</mat-dialog-actions>
